export default function Footer() {
  return (
    <footer className="bg-slate-900 text-gray-300 py-8 sm:py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {/* Brand */}
          <div className="sm:col-span-2 md:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/9bbaefa2db83d27f3b99b300a515e0ca/030dfe57d5d838db27faa02dd2828490.png" 
                alt="EasyTravel Logo" 
                className="w-10 h-10 sm:w-12 sm:h-12 object-contain"
              />
              <span className="text-xl sm:text-2xl font-bold text-white" style={{ fontFamily: '"Inter", "Helvetica Neue", sans-serif' }}>
                EasyTravel
              </span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Uw platform voor onafhankelijke regie in groepsvervoer met 24/7 realtime data.
            </p>
          </div>

          {/* Product */}
          <div>
            <h3 className="text-white font-bold mb-4 text-sm sm:text-base">Product</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="#usp" className="hover:text-teal-400 transition-colors cursor-pointer">Voordelen</a></li>
              <li><a href="#workflow" className="hover:text-teal-400 transition-colors cursor-pointer">Proces</a></li>
              <li><a href="#architectuur" className="hover:text-teal-400 transition-colors cursor-pointer">Technologie</a></li>
              <li><a href="#cases" className="hover:text-teal-400 transition-colors cursor-pointer">Cases</a></li>
            </ul>
          </div>

          {/* Modules */}
          <div>
            <h3 className="text-white font-bold mb-4 text-sm sm:text-base">Modules</h3>
            <ul className="space-y-2 text-sm">
              <li className="hover:text-teal-400 transition-colors cursor-pointer">Data Import</li>
              <li className="hover:text-teal-400 transition-colors cursor-pointer">Planning</li>
              <li className="hover:text-teal-400 transition-colors cursor-pointer">Monitoring</li>
              <li className="hover:text-teal-400 transition-colors cursor-pointer">Afrekening</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-bold mb-4 text-sm sm:text-base">Contact</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <i className="ri-building-line text-teal-400 mt-1 flex-shrink-0"></i>
                <div>
                  <div className="font-semibold text-white">EasyTravel B.V.</div>
                  <div>Waaldijk 29</div>
                  <div>6677MB Slijk Ewijk</div>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-phone-line text-teal-400 mt-1 flex-shrink-0"></i>
                <div>
                  <div>T: +31 85 1249301</div>
                  <div>M: +31 620032937</div>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-mail-line text-teal-400 mt-1 flex-shrink-0"></i>
                <span className="break-all">info@easytravel.nl</span>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-bank-card-line text-teal-400 mt-1 flex-shrink-0"></i>
                <div>
                  <div>KvK: 17127153</div>
                  <div className="text-gray-400 text-xs mt-1 leading-relaxed">
                    EasyTravel is een geregistreerde handelsnaam van E.Bossink Holding B.V.
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="text-sm text-gray-400 text-center md:text-left">
            © 2025 EasyTravel. Alle rechten voorbehouden.
          </div>
          <div className="flex items-center space-x-6">
            <a href="https://readdy.ai/?origin=logo" className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
